import React from 'react';
import { Card, CardContent } from '../ui/card';
import { trustBadges } from '../../enhancedMock';
import { iconMap } from './iconMap';

export const TrustBadges = () => (
  <section data-testid="trust-badges-section" className="py-10 md:py-16 px-4 bg-gradient-to-r from-primaryOrange/10 to-accentOrange/10 relative z-10">
    <div className="container mx-auto">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
        {trustBadges.map((badge) => {
          const Icon = iconMap[badge.icon];
          return (
            <Card key={badge.id} className="border-2 border-primaryOrange/20 bg-white hover:shadow-xl transition-all text-center">
              <CardContent className="pt-4 md:pt-6 px-2 md:px-4">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-primaryOrange rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                  <Icon className="text-white" size={24} />
                </div>
                <h3 className="text-sm md:text-xl font-bold text-darkBrown mb-1">{badge.title}</h3>
                <p className="text-xs md:text-sm text-gray-600">{badge.subtitle}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
